import { getSiteList, SiteItem, SiteType } from "@/services/global";
import { useModel, useRequest } from "@umijs/max";
import { useMemo, useState } from "react";

/** 等待当前用户认证完成后读取站点，避免登录回调期间发出未授权请求。 */
export default function useSiteModel() {
  const { initialState } = useModel("@@initialState");
  const [currentSite, setCurrentSite] = useState<SiteType>(
    (Number(localStorage.getItem("currentSite")) as SiteType) || SiteType.ALL
  );
  const { data: siteListData } = useRequest(getSiteList, {
    ready: Boolean(initialState?.currentUser),
    refreshDeps: [],
  });
  const siteList = useMemo(() => {
    const tempList = [
      {
        label: "全部站点",
        value: SiteType.ALL,
        key: SiteType.ALL,
      },
      ...(siteListData?.map((item: SiteItem) => ({
        label: item.label,
        value: item.value,
        key: item.value,
      })) || []),
    ];
    return tempList;
  }, [siteListData]);

  const onlySiteList = siteList.filter((item) => item.value !== SiteType.ALL);

  return {
    siteList,
    onlySiteList,
    currentSite,
    setCurrentSite,
  };
}
